import { gmcToMMCMappingGridWithSignInStyles } from './grid-styles';
import { mappingEditorCalloutStyles } from './mapping-editor-styles';

// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
export const mappingGridStyles = ({ iconFontFamily, palette }) => ({
  '.gmc-to-mmc-css-wrapper': gmcToMMCMappingGridWithSignInStyles({ iconFontFamily, palette }),
  '.mapping-editor-callout': mappingEditorCalloutStyles({ iconFontFamily, palette }),
});

export const detailsListGridErrorText = () => ({
  color: '#605e5c',
  fontSize: '26px',
  lineHeight: '36px',
});
